module.exports = __webpack_public_path__ + "img/kuaisuxunjia.a2d4fee.svg";